
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"7","cy":"7","r":"7","fill":"#492774"}}),_c('path',{attrs:{"d":"M10.5 8.5c0 .828-1.567 1.5-3.5 1.5s-3.5-.672-3.5-1.5","stroke":"#fff","stroke-linecap":"round"}}),_c('ellipse',{attrs:{"cx":"7","cy":"5.5","rx":"3.5","ry":"1.5","fill":"#593289","stroke":"#fff","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M3.5 5.5v3M10.5 5.5v3","stroke":"#fff"}})])
          )
        }
      }
    